export const AUTH_TOKEN_KEY = 'auth_token_str';
export const AUTH_REFRESH_TOKEN_KEY = 'auth_r_token_str';
export { GENDER } from './gender.constant';